import React from "react";
import ServiceRequestForm from "./ServiceRequestForm";

export default function LaptopServiceRequestForm() {
  return <ServiceRequestForm serviceType="LaptopService" title="Laptop" />;
}

